module.exports = __webpack_public_path__ + "assets/img/86.16e12c91.jpg";